import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultSidebarComponent } from './components/default-sidebar/default-sidebar.component';
import { StateSidebarDirective } from './directives/state-sidebar.directive';
import { StateSidebarService } from './services/state-sidebar.service';
import { SlideActionDirective } from './directives/slide-action.directive';
import { SlideToOpenDirective } from './directives/slide-to-open.directive';
import { MenuOptionGroupComponent } from './components/menu-option-group/menu-option-group.component';
import { MenuOptionComponent } from './components/menu-option/menu-option.component';
import { WidgetModule } from '../widget/widget.module';
import { AngularResizedEventModule } from 'angular-resize-event';
import { CoreModule } from '../core/core.module';
import { Common2Module } from 'projects/common/src/app/app.module';
import { DinamicSidebarDirective } from './directives/dinamic-sidebar.directive';

@NgModule({
  declarations: [
    DefaultSidebarComponent,
    StateSidebarDirective,
    SlideActionDirective,
    SlideToOpenDirective,
    MenuOptionGroupComponent,
    MenuOptionComponent,
    DinamicSidebarDirective
  ],
  imports: [
    CommonModule,
    WidgetModule,
    CoreModule,
    AngularResizedEventModule,
    Common2Module.forRoot(),
  ],
  exports: [
    DefaultSidebarComponent,
    DinamicSidebarDirective
  ],
  providers: [
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: (appConfig: StateSidebarService) => () => appConfig,
    //   deps: [StateSidebarService],
    //   multi: true
    // }
  ]
})
export class SidebarModule { }
